import { writable } from "svelte/store";
import { capturePHEvent } from "../lib/posthog";

export const modalOpen = writable(false);
export const footprintPrice = writable(0);

// Ignore first modal close event from subscribing by capturing this count.
let modalCloseCount = 0;
modalOpen.subscribe((value) => {
  // Open event is handled by relevant component since we differentiate between button and badge clicks.
  if (!value && modalCloseCount++ > 0) capturePHEvent("modal_closed");
});
